<!-- 生物药中间体 -->
<template>
	<CommonTablePage
		type="bioDrugIntermediate"
		title-value="生物药中间体"
		placeholder="请输入名称/别名/用途/CAS号"
		:columns="columns"
		api-type="bio_drug_intermediate"
	/>
</template>

<script setup lang="ts">
import { ref } from "vue";
import CommonTablePage from "./components/CommonTablePage.vue";
defineOptions({
	name: "BioDrugIntermediate"
});
const columns = ref([
	{
		prop: "name",
		label: "名称"
	},
	{
		prop: "aliasUsage",
		label: "别名/用途"
	},
	{
		prop: "casNumber",
		label: "CAS号"
	},
	{
		prop: "purity",
		label: "纯度"
	},
	{
		prop: "productionMethod",
		label: "生产方式"
	}
]);
</script>
